exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".details-wrapper[data-v-534b17ec]{display:flex;align-items:stretch}.detail-type[data-v-534b17ec]{margin:0;display:flex;align-items:center;font-weight:700;font-size:14px;line-height:1.1;padding:5px 12px;border:1px solid #e6e6e6;border-right-width:0;border-radius:5px 0 0 5px}.detail-type-value-wrapper[data-v-534b17ec]{display:flex;gap:5px;align-items:center;padding:6px;flex-wrap:wrap;border-radius:0 5px 5px 0;background-color:#e6e6e6}.detail-type-value[data-v-534b17ec]{border-radius:5px;font-size:14px;line-height:1;padding:4px 12px;background-color:#fff}", ""]);

// exports
